import "./ReactionMenu.css";

export const REACTION_GIFS = {
  "👍": "/reactions/Okay.gif",
  "👏": "/reactions/clap.gif",
  "❤️": "/reactions/love.gif",
  "👎": "/reactions/loose.gif",
  "😢": "/reactions/triste.gif",
  "🤯": "/reactions/Mind_blown.gif",
  "😄": "/reactions/Laugh.gif",
  "🤔": "/reactions/Interrogation.gif",
  "✋": "/reactions/Raised_hand.gif"
};

const REACTIONS = Object.keys(REACTION_GIFS);

export default function ReactionMenu({ onSelectReaction, onRaiseHand }) {
  const reactions = REACTIONS.filter(r => r !== "✋");
  const hand = "✋";

  return (
    <div className="reaction-menu">
      <div className="reaction-group">
      {reactions.map((emoji, i) => (
        <div 
          key={i}
          className="reaction-item"
          onClick={() =>
              onSelectReaction({
                emoji,
                gif: REACTION_GIFS[emoji],
              })
            }
          >
            {emoji}
          </div>
        ))}
      </div>

      <div
        className="reaction-item reaction-hand"
        onClick={onRaiseHand}
      >
        {hand}
      </div>
    </div>
  );
}
